export const TRIAL_PLAN = "Trial";

export const PAID_PLAN = "Paid";

export const FREE_PLAN = "Free";
